import CartBox from '../../components/CartBox/CartBoxSection';
import { useNotification } from '../../context/NotificationContext';
import { usePrompt } from '../../context/PromptContext';
import { useCart } from '../../context/CartContext';
import './accountcart.scss';
import { NavLink } from 'react-router-dom';

const AccountCart = () => {
 const { clearCart, cartData } = useCart();
 const { notify } = useNotification();
 const { initPrompt } = usePrompt();

 const handleClear = async () => {
  const callbackFunc = async () => {
   let resp = await clearCart();
   if (resp) {
    notify.success('Cart cleared!');
   }
  };

  initPrompt(
   'Clear your cart?',
   'All products will be cleared from your cart',
   callbackFunc,
  );
 };

 return (
  <div className="accountcart">
   <div className="cartside">
    <CartBox></CartBox>

    {cartData.length >= 1 && (
     <div className="cart_action">
      <div className="button-group">
       <NavLink to={'/cart'}>
        <div className="btn full">Checkout</div>
       </NavLink>
       <NavLink to={'/products'}>
        <div className="btn open">Continue shopping</div>
       </NavLink>
      </div>

      <div className="btn-pack">
       <button
        className="clear-btn"
        onClick={handleClear}
       >
        Clear cart
       </button>
      </div>
     </div>
    )}
   </div>
  </div>
 );
};

export default AccountCart;
